import React, { Component } from 'react';

class Video extends Component {
	render() {
		return (
		<section class="video home">
			<div class="video-tag">
				<div class="c-video">
				</div>
			</div>
		</section>			
		);
	}
}


export default Video